<template>
	<div class="resolution-picker">
		<div :key="resolution" v-for="resolution in resolutions">
			<span
				:class="[
					'resolution-picker__resolution',
					{
						'resolution-picker__resolution--selected':
							resolution == currentResolution
					}
				]"
				@click="setResolution(resolution)"
			>
				{{ resolution }}
			</span>
		</div>
		<help-displayer-icon>
			<p class="resolution-picker__help-text">
				We optimize our benchmarks <br >
				for two display standards:
			</p>
			<div class="resolution-picker__img">
				<img
					src="/images/icons/monitor-screen-resolutions.svg"
					alt="monitors showing two resolutions 1980x1080 and 2560x1440"
				>
			</div>
			<p class="resolution-picker__help-text">
				60fps is recommended. FPS speeds are measured using each game's highest
				graphic setting.
			</p>
		</help-displayer-icon>
	</div>
</template>

<script>
import HelpDisplayerIcon from "@c/generals/help-displayer-icon";
import { isMobile } from "@u/helpers.js";

export default {
	name: "ResolutionPicker",
	components: {
		HelpDisplayerIcon
	},
	props: {
		currentResolution: {
			type: [String, Number],
			required: true
		},
		setResolution: {
			type: Function,
			required: true
		}
	},
	data() {
		return {
			isMobile: isMobile(),
			showResolutionDrawer: false,
			resolutions: [1080, 1440]
		};
	}
};
</script>

<style lang="scss" scoped>
.resolution-picker {
	display: flex;
	position: relative;
	align-items: center;

	&__resolution {
		margin-right: 10px;
		color: #444259;
		font-size: 14px;
		font-weight: bold;
		letter-spacing: 0;
		border-bottom: solid 2px transparent;
		transition: box-shadow 0.3s;
		line-height: initial;
		cursor: pointer;
	}

	&__tooltip-icon {
		width: 16px;
		height: 16px;
		cursor: pointer;
	}

	&__tooltip-icon:hover + &__tooltip-container {
		display: block;
	}

	&__resolution--selected {
		border-bottom: solid 2px #8d29a0;
	}

	&__tooltip-container {
		position: absolute;
		transform: translate(-75%, -101%);
		display: none;
	}

	&__help-text {
		text-align: center;
		font-size: 16px;
		color: #fff;
	}

	&__img {
		padding: 20px 0;
		text-align: center;
		margin-bottom: 10px;
	}
}

.resolution-picker::v-deep {
	.help-tooltip {
		padding: 35px;
	}
}
</style>
